import React from 'react';
import { MarkdownContent } from './MarkdownContent';

interface ReasoningBlockProps {
  content: string;
  id: string;
  isComplete?: boolean;
  className?: string;
}

export const ReasoningBlock: React.FC<ReasoningBlockProps> = ({
  content,
  id,
  isComplete = true,
  className = '',
}) => {
  if (!content.trim()) return null;

  return (
    <div data-msg-id={id} className={`text-xs text-gray-400 ${className}`}>
      <MarkdownContent content={content} variant="thinking" />
    </div>
  );
};
